import moment from 'moment';

export const getDiffDays = (date: number) => {
  const today = moment();
  const diffDate = moment(date);
  return today.diff(diffDate, 'days');
};